import { Eye } from 'lucide-react'
import { useState } from 'react'
import MediaFooter from './MediaFooter'

const Photo = ({ photo, handlePhotoSelectionToggle, selected, onPhotoSelect }) => {
    const [scale, setScale] = useState(1)
    const [showOverlay, setShowOverlay] = useState(false)

    return (
        <div style={{ position: 'relative' }}>
            <div
                className="d-flex flex-column"
                style={{ width: '150px' }}
                onMouseEnter={() => setScale(1.02)}
                onMouseLeave={() => setScale(1)}
            >
                <div
                    className="position-relative"
                    style={{ transition: 'transform 0.2s ease', transform: `scale(${scale})` }}
                    onMouseEnter={() => setShowOverlay(true)}
                    onMouseLeave={() => setShowOverlay(false)}
                    onClick={onPhotoSelect}
                >
                    <img src={photo.url} alt={photo.name} style={imageStyles} />
                    <div className="image-hover-overlay" style={imageOverlayStyles(showOverlay)}>
                        <Eye size={32} opacity={0.9} />
                    </div>
                </div>
                <MediaFooter
                    selected={selected}
                    handleSelectionToggle={handlePhotoSelectionToggle}
                    id={photo.id}
                    name={photo.name}
                />
            </div>
        </div>
    )
}

const imageStyles = {
    cursor: 'pointer',
    borderRadius: '4px',
    width: '150px',
    height: '150px',
    objectFit: 'cover',
}

const imageOverlayStyles = (showOverlay) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.4)',
    display: showOverlay ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
})

export default Photo
